import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { adminService } from '../../services/api';
import { Doctor, PaginatedResponse } from '../../types';
import DataTable from '../common/DataTable';
import LoadingSpinner from '../common/LoadingSpinner';

interface DoctorManagementProps {
  isVisible: boolean;
}

const DoctorManagement: React.FC<DoctorManagementProps> = ({ isVisible }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const { data: doctorsData, isLoading } = useQuery<PaginatedResponse<Doctor>>({
    queryKey: ['admin-doctors', searchTerm],
    keepPreviousData: true,
    queryFn: () => adminService.getDoctorsAdmin({ search: searchTerm }).then(res => res.data),
    enabled: isVisible,
  });


  const columns = [
    {
      key: 'full_name',
      label: 'Nom',
      render: (_: any, doctor: Doctor) => {
        const user = doctor.user_details || doctor.user;
        return `Dr. ${user?.first_name || ''} ${user?.last_name || ''}`.trim() || 'Non défini';
      },
    },
    {
      key: 'speciality',
      label: 'Spécialité',
    },
    {
      key: 'license_number',
      label: 'Numéro de licence',
    },
    {
      key: 'phone',
      label: 'Téléphone',
      render: (_: any, doctor: Doctor) => doctor.phone || 'Non défini',
    },
  ];

  if (!isVisible) return null;

  if (isLoading) return <LoadingSpinner />;

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-lg font-medium text-gray-900">Liste des médecins</h2>
          <p className="mt-1 text-sm text-gray-500">
            Consultez la liste des médecins enregistrés
          </p>
        </div>
      </div>

      <div className="flex items-center space-x-4">
        <div className="flex-1">
          <input
            type="text"
            placeholder="Rechercher un médecin..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-teal-500 focus:ring-teal-500 sm:text-sm text-gray-900"
          />
        </div>
      </div>

      <DataTable
        data={doctorsData?.results || []}
        columns={columns}
        loading={isLoading}
      />
    </div>
  );
};

export default DoctorManagement;